import React, { useRef, useState } from 'react'
import { CiLink } from 'react-icons/ci'
import LinkModal from '../../Movie/LinkModal'
// import LinkModal from '/LinkModal'
import Config from '../../../Config/Config.json'
import { personDynamicHint } from '../../Data/StaticPersonandMoviedata'

const TextAreaWithLink = ({ labels, placeholders, value, onChange, setChangesMade, type }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedText, setSelectedText] = useState('')
  const [link, setLink] = useState('')
  const [index, setIndex] = useState('')
  const [isTextSelected, setIsTextSelected] = useState({
    textArea1: false,
    textArea2: false,
  })
  const inputReferences = {
    textArea1: useRef(),
    textArea2: useRef(),
  }

  const handleButtonClick = index => {
    const selectedText = inputReferences[`textArea${index + 1}`].current.value
      .substring(
        inputReferences[`textArea${index + 1}`].current.selectionStart,
        inputReferences[`textArea${index + 1}`].current.selectionEnd,
      )
      .trim()
    setSelectedText(selectedText)
    setModalOpen(true)
    setIndex(index)
  }

  const handleSaveLink = link => {
    const textarea = inputReferences[`textArea${index + 1}`].current

    if (textarea.selectionStart !== undefined && textarea.selectionEnd !== undefined) {
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      // const selectedText =
      // currentDescription === 'Bio'
      // ? shortbio.substring(start, end)
      // : shortbiote.substring(start, end)
      // let updatedText = ''
      // Object.entries(inputReferences).forEach(([_key, ref]) => {
      // const textarea = ref.current
      // const start = textarea.selectionStart
      // const end = textarea.selectionEnd
      if (selectedText) {
        let updatedText = ''
        let baseUrl = ''
        if (Config.Environment === 'Production') {
          baseUrl = 'https://telugu.yousay.tv'
        } else if (Config.Environment === 'Development') {
          baseUrl = 'https://stagingyousay.ktree.org'
        } else {
          baseUrl = 'https://stagingyousay.ktree.org'
        }

        if (link.includes(baseUrl)) {
          const path = link.includes(`${baseUrl}/en/tfidb/`)
            ? `${baseUrl}/en/tfidb`
            : `${baseUrl}/tfidb`

          updatedText = `${textarea.value.substring(0, start)}<a href='${link.replace(
            path,
            '',
          )}'>${selectedText}</a>${textarea.value.substring(end)}`
        } else {
          updatedText = `${textarea.value.substring(
            0,
            start,
          )}<a href='${link}' target='_blank'>${selectedText}</a>${textarea.value.substring(end)}`
        }

        // const updatedText = `${textarea.value.substring(
        //   0,
        //   start,
        // )}<a href='${link}'>${selectedText}</a>${textarea.value.substring(end)}`
        const newValue = type === 'basic' ? value : [...value]

        newValue[index] = updatedText
        onChange(newValue)
        // })
        if (type === 'basic') {
          setChangesMade('Almamater_En', true)
        } else {
          setChangesMade(true)
        }

        setModalOpen(false)
      }
    }
  }

  const handleSelectionChange = (event, index) => {
    const textarea = event.target
    setIsTextSelected({
      ...isTextSelected,
      [`textArea${index}`]: textarea.selectionStart !== textarea.selectionEnd,
    })
  }

  const handleChange = (event, index) => {
    const newValue = type === 'basic' ? value : [...value]

    newValue[index] = event.target.value
    onChange(newValue)
  }

  return (
    <div>
      <div className='row'>
        {labels.map((label, index) => (
          <div className='col-md-6' key={index}>
            <label>
              {type === 'basic' ? label : placeholders[index]}
              {personDynamicHint[label]}
            </label>
            <textarea
              className='form-control'
              ref={inputReferences[`textArea${index + 1}`]}
              placeholder={placeholders[index]}
              value={value[index]}
              rows={5}
              cols={20}
              onChange={event => handleChange(event, index)}
              onSelect={event => handleSelectionChange(event, index + 1)}
            />
            <button
              type='button'
              className='btn btn-primary mt-2 mb-2'
              onClick={() => handleButtonClick(index)}
              disabled={!isTextSelected[`textArea${index + 1}`]}
            >
              <CiLink />
            </button>
          </div>
        ))}
      </div>
      <LinkModal
        isOpen={modalOpen}
        selectedText={selectedText}
        link={link}
        setLink={setLink}
        onClose={() => {
          setModalOpen(false)
          setIsTextSelected({
            textArea1: false,
            textArea2: false,
          })
          setIndex('')
          setSelectedText('')
          setLink('')
        }}
        onSave={link => {
          setModalOpen(false)
          handleSaveLink(link)
          setSelectedText('')
          setLink('')
          setIsTextSelected({
            textArea1: false,
            textArea2: false,
          })
          setIndex('')
        }}
      />
    </div>
  )
}

export default TextAreaWithLink
